<template>
    <div class="text-[16px] text-red-300" v-if="message">
        <span v-html="errorMessage"></span>
    </div>
</template>
<script>
export default {
    name: "FieldError",
    props: {
        fieldName: {
            type: String,
            default: "",
        },
        message: {
            type: String,
            default: null,
        },
    },
    computed: {
        errorMessage() {
            let messages = {
                "validation.required":
                    '<span class="font-semibold">' +
                    this.fieldName +
                    "</span> is a required field.",
                "validation.confirmed":
                    '<span class="font-semibold">' +
                    this.fieldName +
                    "</span> confirmation does not match.",
                "validation.min.string":
                    '<span class="font-semibold">' +
                    this.fieldName +
                    "</span> is too short.",
                "validation.email":
                    '<span class="font-semibold">' +
                    this.fieldName +
                    "</span> must be a valid email address.",
            };

            let errorMessage = "";

            if (messages[this.message]) {
                errorMessage = messages[this.message];
            } else {
                errorMessage = this.message;
            }

            return errorMessage;
        },
    },
};
</script>
